import { Component, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { DatePipe } from "@angular/common";
import { AppService } from "../services/app.service";
import { environment } from "src/environments/environment";
import { Lightbox } from "ngx-lightbox";
import { Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { BsModalService, BsModalRef } from "ngx-bootstrap/modal";
import { SupportService } from "../services/support-service";

@Component({
  selector: "app-detail-page",
  templateUrl: "./detail-page.component.html",
})
export class DetailPageComponent implements OnInit {
  @ViewChild("confirmationpopup") confirmationpopup: TemplateRef<any>;
  scheduleDetails: any;
  totalItems: any;
  maxSizeItem = 10;
  currentPage = 1;

  timezone_offset_min: any;
  today = new Date();
  offset_hrs: any;
  offset_min: any;
  tcView: any;
  schedules: any;
  readMoreContent: any;
  readMoreExtraConent: any;
  readmore = true;
  intialContent: any = "";
  tcAddress: any;
  tcAddressShow:any;
  lat = 0;
  lng = 0;
  locationurl = "";
  cloudFrontendurl = "";
  scheduledData: any = {};
  patientData: any;
  path: any;
  page: number;

  scheduleappointmentid = "";
  reviewData = [];
  formatter: any;
  homeDate: any = this.formatHomeDate(this.today);
  homeDatePlaceHolder: any = this.formatHomeDate(this.today);
  homeLocation: any;
  homeLocationPlaceholder: any = "Location";
  homeInsuranceType: any;
  homeInsurance: any;
  selectProcedureList: any = [];
  paymode: any;
  countryCode: any;
  currencysymbol = environment.symbol[0];
  disabledInsType = false;
  showAddProcedureFormMob = false;
  placeholerCptCode: any;
  countryId: any = 231;
  multiplePro = false;
  insuranceList: any = [];
  rating: any;
  savedImageList: any = [];
  tcPhotos: any;
  bannerimage = "";
  workhours: any;
  noslot = true;
  activetab = "overview-tab";
  appointData: any = {};
  timeSlotDisabeld = false;
  scheduleToTime: any;
  desktopView = false;
  mobileView = false;
  modalRef: BsModalRef;
  config = {
    ignoreBackdropClick: true,
  };
  constructor(
    private datePipe: DatePipe,
    private supportService: SupportService,
    private appService: AppService,
    private toastr: ToastrService,
    private lightbox: Lightbox,
    private router: Router,
    private modalService: BsModalService
  ) {
    this.cloudFrontendurl = environment.cloudFrontURL;
    this.scheduleDetails = JSON.parse(localStorage.getItem("tcdetail"));
    this.bannerimage = this.scheduleDetails.profile;

    this.path = this.router.url;
    const Splitpath = this.path.split("/");
    if (Splitpath && Splitpath.length === 3) {
      this.scheduleappointmentid = Splitpath[2];
    }

    if (this.scheduleDetails && this.scheduleDetails.cptCodes) {
      sessionStorage.getItem("scheduleData") !== null
        ? (this.scheduledData = JSON.parse(
            sessionStorage.getItem("scheduleData")
          ))
        : (this.scheduledData = {});

      this.timeslot();
      this.workHour(this.scheduleDetails.scheduleOn, this.scheduleDetails.tcId);
      this.getReview();
      this.getTcPhotos();
      this.getAllReview(this.scheduleDetails.tcId, "");

      sessionStorage.getItem("patientData") != null
        ? (this.patientData = JSON.parse(sessionStorage.getItem("patientData")))
        : (this.patientData = {});
      if (
        !this.scheduledData ||
        !this.patientData ||
        this.scheduledData === {} ||
        this.patientData === {}
      ) {
        this.router.navigate(["/home"]);
      } else {
        this.supportService.patientname.next(this.patientData.firstName);
      }
      this.populateData();
    } else {
      this.workHour(this.scheduleDetails.scheduleOn, this.scheduleDetails.tcId);
      this.getReview();
      this.getTcPhotos();
      this.getAllReview(this.scheduleDetails.tcId, "");
      this.tcView = this.scheduleDetails.tcView;
      this.tcView.rating = Math.floor(this.tcView.rating);
      this.settingvalue();
    }
  }

  ngOnInit() {}

  pageChanged(event: any): void {
    this.getAllReview(this.scheduleDetails.tcId, event);
  }
  getAllReview(tcId, event) {
    let data;
    if (event) {
      data = {
        type: "patient",
        pagenumber: event.page,
        pagesize: this.maxSizeItem,
        patientType: "all",
        tcId: tcId,
        startDate: "",
        endDate: "",
        sortColumn: "",
        sortType: "",
        search: "",
      };
    } else {
      data = {
        type: "patient",
        pagenumber: 1,
        pagesize: 10,
        patientType: "all",
        tcId: tcId,
        startDate: "",
        endDate: "",
        sortColumn: "",
        sortType: "",
        search: "",
      };
    }

    this.appService.getAllReviewByTc(data).subscribe((res: any) => {
      this.reviewData = [];
      if (res && res.entity) {
        this.reviewData = res.entity;
        this.totalItems = res["count"];

        for (let index = 0; index < this.reviewData.length; index++) {
          this.reviewData[index].color = this.getThemeColor();
        }
      }
    });
  }

  formatHomeDate(date) {
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    let day = date.getDate();
    if (day && day < 10) {
      day = "0" + day;
    }
    const monthIndex = date.getMonth();
    const year = date.getFullYear();
    return monthNames[monthIndex] + " " + day + "," + year;
  }

  getPatientIntial(firstname, lastName) {
    const name = firstname + " " + lastName;
    const initials = name.match(/\b\w/g) || [];
    return ((initials.shift() || "") + (initials.pop() || "")).toUpperCase();
  }

  getThemeColor() {
    // Math.random() is safe here — used only for cosmetic CSS class selection, no security implication.
    return "profile-img profile-theme" + (Math.floor(Math.random() * 4) + 1);
  }

  formatHomeDateStr(date) {
    const datearray = date.toString().split("-");
    if (datearray.length > 1) {
      const monthNames = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];

      let day = datearray[2];
      if (day && day.length < 1) {
        day = "0" + day;
      }
      const monthIndex = +datearray[1];
      const year = datearray[0];

      return monthNames[monthIndex - 1] + " " + day + "," + year;
    }
    return null;
  }

  populateData() {
    if (this.scheduledData) {
      this.homeDate = this.formatHomeDateStr(this.scheduledData.scheduleOn);
      this.homeDatePlaceHolder = this.formatHomeDateStr(
        this.scheduledData.scheduleOn
      );
      this.homeLocation = this.scheduledData.location;
      this.homeLocationPlaceholder = "Location";
      this.paymode = this.scheduledData.payMode;
      this.countryCode = this.scheduledData.countryCode;
      localStorage.setItem("countryCodeNew", this.countryCode);
      this.currencysymbol =
        this.countryCode == "US"
          ? environment.symbol[0]
          : environment.symbol[1];

      this.formatter = new Intl.NumberFormat("en-US", {
        minimumFractionDigits: 0,
      });
      if (this.paymode === "self") {
        this.homeInsurance = "self";
        this.homeInsuranceType = "";
        this.disabledInsType = true;
      } else {
        this.homeInsurance = this.scheduledData.insuranceId;
        this.homeInsuranceType = this.scheduledData.inType;
        this.disabledInsType = false;
      }
      this.lat = this.scheduledData.latitude;
      this.lng = this.scheduledData.longitude;
      this.selectProcedureList = this.scheduledData.selectProcedureList;
      if (this.selectProcedureList && this.selectProcedureList.length >= 5) {
        this.showAddProcedureFormMob = false;
      } else {
        this.showAddProcedureFormMob = true;
      }
      if (this.selectProcedureList && this.selectProcedureList.length > 1) {
        this.multiplePro = true;
      }
      if (
        this.countryCode &&
        this.countryCode !== null &&
        this.countryCode === "IN"
      ) {
        this.countryId = 101;
        this.placeholerCptCode = "Procedure Name";
      }
      if (
        this.countryCode &&
        this.countryCode !== null &&
        this.countryCode === "US"
      ) {
        this.countryId = 231;
        this.placeholerCptCode = "CPT Code";
      }
      this.getallinsurancebycountry();
    }
  }

  getallinsurancebycountry() {
    const data = {
      countryId: this.countryId,
    };

    this.appService.getallinsurancebycountry(data).subscribe(
      (res) => {
        if (
          res &&
          res["status"] &&
          res["status"]["status"] &&
          res["status"]["status"] === 200
        ) {
          this.insuranceList = res["entity"];
        }
      },
      (err) => {
        this.appService.sessionOut(err);
      }
    );
  }

  getReview() {
    if (this.scheduleDetails) {
      this.appService
        .ratingCount(this.scheduleDetails.tcId)
        .subscribe((count) => {
          if (count && count["entity"]) {
            this.rating = count["entity"];
          }
        });
    }
  }

  openImage(index) {
    this.lightbox.open(this.savedImageList, index);
  }

  close(): void {
    this.lightbox.close();
  }

  getTcPhotos() {
    if (this.scheduleDetails) {
      this.appService
        .getalluploadedpicsbytc(this.scheduleDetails.tcId)
        .subscribe((res) => {
          if (res && res["entity"] && res["entity"].length > 0) {
            this.tcPhotos = res["entity"];
            this.savedImageList = [];
            this.bannerimage = this.tcPhotos[this.tcPhotos.length - 1]["image"];
            for (let i = 0; i < res["entity"].length; i++) {
              const src = environment.cloudFrontURL + res["entity"][i].image;
              const caption = "Profile photo" + (i + 1);
              const thumb = environment.cloudFrontURL + res["entity"][i].image;
              const album = {
                src: src,
                caption: caption,
                thumb: thumb,
                id: res["entity"][i].id,
                backenddata: true,
                key: null,
              };
              this.savedImageList.push(album);
            }
          } else {
            this.tcPhotos = [];
            this.savedImageList = [];
          }
        });
    }
  }

  workHour(datestr, tcid) {
    this.appService
      .checkGivenDateIsHolidayOrNotByTcid(datestr, tcid)
      .subscribe((res) => {
        if (res && res["entity"]) {
          this.workhours = res["entity"];
        } else {
          this.workhours = null;
        }
      });
  }

  getRoundedDate = (minutes, d = new Date()) => {
    const ms = 1000 * 60 * minutes; // convert minutes to ms
    return new Date(Math.round(d.getTime() / ms) * ms);
  };

  timeslot() {
    const now = new Date();
    const zoneDate = new Date(now.getTime() + now.getTimezoneOffset() * 60000);
    zoneDate.setMinutes(
      zoneDate.getMinutes() + this.scheduledData.offsetmin + 15
    );
    const roundedDate = this.getRoundedDate(15, zoneDate);
    roundedDate.setSeconds(0);

    const data = {
      scheduleOn: this.scheduleDetails.scheduleOn,
      cptCodes: this.scheduleDetails.cptCodes,
      currentDate: this.datePipe.transform(roundedDate, "yyyy-MM-dd"),
      tcId: this.scheduleDetails.tcId,
      timeZone: "",
      currentTime: this.datePipe.transform(roundedDate, "hh:mm aa"),
    };
    this.appService.gettcscheduleListByTc(data).subscribe((schedule: any) => {
      if (schedule.status) {
        if (schedule.status.status === 200) {
          this.schedules = [];
          this.tcView = schedule["entity"]["tcView"];
          this.tcView.rating = Math.floor(this.tcView.rating);
          this.schedules = schedule["entity"]["schedules"][1]["schedules"];
          this.settingvalue();
        }
      }
    });
  }

  settingvalue() {
    if (
      this.tcView &&
      this.tcView.aboutUs &&
      this.tcView.aboutUs.length > 500
    ) {
      this.readMoreContent = this.tcView.aboutUs.toString().substring(0, 499);
      this.intialContent = this.readMoreContent;
    } else if (this.tcView && this.tcView.aboutUs) {
      this.intialContent = this.tcView.aboutUs;
    }

    this.lat = +this.tcView.latitude;
    this.lng = +this.tcView.longitude;
    this.locationurl =
      "https://www.google.com/maps/dir/?api=1&destination=" +
      this.lat +
      "," +
      this.lng;
    this.checkDate();
    if (this.tcView) {
      this.tcAddress = "";
      this.tcAddressShow = "";
      if (this.tcView.addressLine1) {
        this.tcAddress = this.tcView.addressLine1 + ", ";
      }
      if (this.tcView.addressLine2) {
        this.tcAddress += this.tcView.addressLine2 + ", ";
      }
      if (this.tcView.cityName) {
        this.tcAddress += this.tcView.cityName + ", ";
        this.tcAddressShow = this.tcView.cityName + ", ";
      }
      if (this.tcView.stateCode) {
        this.tcAddress += this.tcView.stateCode + ", ";
        this.tcAddressShow += this.tcView.stateCode + ", ";
      }
      if (this.tcView.countryCode) {
        this.tcAddress += this.tcView.countryCode;
        this.tcAddressShow += this.tcView.countryCode;
      }

      if (this.tcView.tcFacebook && !this.tcView.tcFacebook.includes("http")) {
        if (!this.tcView.tcFacebook.includes("www.")) {
          this.tcView.tcFacebook =
            "https://www.facebook.com/" + this.tcView.tcFacebook;
        } else {
          this.tcView.tcFacebook = "https://" + this.tcView.tcFacebook;
        }
      }

      if (this.tcView.tcTwitter && !this.tcView.tcTwitter.includes("http")) {
        if (!this.tcView.tcTwitter.includes("www.")) {
          this.tcView.tcTwitter =
            "https://twitter.com/" + this.tcView.tcTwitter;
        } else {
          this.tcView.tcTwitter = "https://" + this.tcView.tcTwitter;
        }
      }

      if (this.tcView.instagramUrl && !this.tcView.instagramUrl.includes("http")) {
        if (!this.tcView.instagramUrl.includes("www.")) {
          this.tcView.instagramUrl =
            "https://instagram.com/" + this.tcView.instagramUrl;
        } else {
          this.tcView.instagramUrl = "https://" + this.tcView.instagramUrl;
        }
      }

      if (this.tcView.linkedInUrl && !this.tcView.linkedInUrl.includes("http")) {
        if (!this.tcView.linkedInUrl.includes("www.")) {
          this.tcView.linkedInUrl =
            "https://linkedin.com/" + this.tcView.linkedInUrl;
        } else {
          this.tcView.linkedInUrl = "https://" + this.tcView.linkedInUrl;
        }
      }

      if (this.tcView.tcWebsite && !this.tcView.tcWebsite.includes("http")) {
        if (!this.tcView.tcWebsite.includes("www.")) {
          this.tcView.tcWebsite = "https://" + this.tcView.tcWebsite;
        } else {
          this.tcView.tcWebsite = "https://" + this.tcView.tcWebsite;
        }
      }
    }
  }

  checkDate() {
    if (this.schedules && this.schedules.length > 0) {
      this.noslot = false;
    }
  }

  scrollTop(value) {
    document.getElementById(value).scrollIntoView({ behavior: "smooth" });
  }

  gottopage(type) {
    document.getElementById(type).scrollIntoView({ behavior: "smooth" });
    this.activetab = type;
    setTimeout(() => {
      document.body.scrollTop -= 50; // For Safari
      document.documentElement.scrollTop -= 50; // For Chrome, Firefox, IE and Opera
    }, 900);
  }

  scheduleappointmentPopup(type) {
    this.modalRef.hide();
    sessionStorage.getItem("appointData") != null
      ? (this.appointData = JSON.parse(sessionStorage.getItem("appointData")))
      : (this.appointData = {});
    if (!this.appointData) {
      this.router.navigate(["/home"]);
    }
    const data = this.appointData;
    if (type == "yes") {
      data.preAuthorized = true;
    } else {
      data.preAuthorized = false;
    }
    // data.push({patientType: 'Sched'});
    // console.log(data);
    let patientType = "Sched";
    if (this.desktopView && !this.mobileView) {
      patientType = "Sched";
    } else if (!this.desktopView && this.mobileView) {
      patientType = "Mobile";
    }

    data["patientType"] = patientType;
    this.appService.scheduleappointment(data).subscribe(
      (res) => {
        if (res && res["status"] && res["status"]["status"] === 200) {
          sessionStorage.setItem("appointData", null);
          if (type === "yes") {
            this.router.navigate(["/patient-profile", res["entity"].id]);
          } else {
            this.router.navigate(["/pre-autho2", res["entity"].id]);
          }
        }
      },
      (err) => {
        this.toastr.error(err.error.status.msg);
      }
    );
  }

  confirmationPopAfterSave(timeslot) {
    if (timeslot.procedureInputs[0] && !timeslot.procedureInputs[0].disabled) {
      this.timeSlotDisabeld = true;
      if (timeslot.procedureInputs && timeslot.procedureInputs.length > 0) {
        this.scheduleToTime =
          timeslot.procedureInputs[timeslot.procedureInputs.length - 1].endTime;
      }
      this.triggerPopup(timeslot);
    }
  }

  triggerPopup(timeslot) {
    this.scheduleappointment(timeslot);
  }

  onResize(innerWidth) {
    if (innerWidth < 1025) {
      this.desktopView = false;
      this.mobileView = true;
    } else {
      this.desktopView = true;
      this.mobileView = false;
    }
  }

  scheduleappointment(timeslot) {
    let patientType = "Sched";
    if (this.desktopView && !this.mobileView) {
      patientType = "Sched";
    } else if (!this.desktopView && this.mobileView) {
      patientType = "Mobile";
    }

    const schedInsuranceInput = [];
    schedInsuranceInput.push({
      insurance: {
        id:
          this.homeInsurance && this.homeInsurance !== "self"
            ? this.homeInsurance
            : 0,
      },
      insuranceType: { id: this.homeInsuranceType },
    });

    const data = {
      scheduleId: this.scheduleappointmentid,
      scheduledOn: this.datePipe.transform(this.homeDate, "yyyy-MM-dd"),
      scheduledOnStr: this.datePipe.transform(this.homeDate, "yyyy-MM-dd"),
      choosenLocation: this.homeLocation,
      latitude: this.lat,
      longitude: this.lng,
      payMode: this.paymode,
      schedInsuranceInput:
        schedInsuranceInput && schedInsuranceInput.length > 0
          ? schedInsuranceInput
          : null,
      patient: {
        id: this.patientData.id,
        firstName: this.patientData.firstName,
        lastName: this.patientData.lastName,
        patientEmail: this.patientData.patientEmail,
        patientPhone: this.patientData.patientPhone,
        patientPhoneCode: this.patientData.patientPhoneCode,
        gender: this.patientData.gender,
      },
      procedureInputs: timeslot.procedureInputs,
      preAuthorized:
        this.countryId === "IN" && this.paymode === "insurance" ? true : false,
      scheduleFromTime: timeslot.procedureInputs[0].startTime,
      scheduleToTime: this.scheduleToTime,
      timeZone: this.convetTimeZoneOffsetToTime(),
      totalAmount: this.tcView.totalAmount,
      schedMed: true,
      schedStatusId: 1,
      testCenterId: this.tcView.testcenterId,
      patientType: patientType,
    };

    if (
      this.countryCode === "IN" ||
      (this.countryCode === "US" && this.paymode === "self")
    ) {
      this.appService.scheduleappointment(data).subscribe(
        (res) => {
          this.timeSlotDisabeld = false;
          if (res && res["status"] && res["status"]["status"] === 200) {
            sessionStorage.setItem("scheduleData", null);
            sessionStorage.setItem("patientData", null);
            this.router.navigate(["/patient-profile", res["entity"].id]);
          }
        },
        (err) => {
          this.timeSlotDisabeld = false;
          this.toastr.error(err.error.status.msg);
        }
      );
    } else {
      sessionStorage.setItem("appointData", JSON.stringify(data));
      sessionStorage.setItem("scheduleData", null);
      sessionStorage.setItem("patientData", null);
      if (this.scheduleappointmentid && this.scheduleappointmentid !== "") {
        this.openModal(this.confirmationpopup);
      } else {
        this.openModal(this.confirmationpopup);
      }
    }
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(
      template,
      Object.assign(this.config, { class: "popup-center" })
    );
  }

  formateMask(phonecode) {
    if (phonecode) {
      if (phonecode === "+91" || phonecode === +91) {
        return environment.indiaPhoneMask;
      } else {
        return environment.usPhoneMask;
      }
    }
  }

  showContent() {
    if (this.readmore) {
      this.intialContent = this.tcView.aboutUs;
      this.readmore = false;
    } else {
      this.intialContent = this.readMoreContent;
      this.readmore = true;
    }
  }

  convetTimeZoneOffsetToTime() {
    this.timezone_offset_min = new Date().getTimezoneOffset();
    this.offset_hrs = Math.abs(this.timezone_offset_min / 60);
    this.offset_min = Math.abs(this.timezone_offset_min % 60);
    let timezone_standard = "";
    if (this.offset_hrs < 10) {
      this.offset_hrs = "0" + Math.floor(this.offset_hrs);
    }
    if (this.offset_min < 10) {
      this.offset_min = "0" + this.offset_min;
    }
    if (this.timezone_offset_min < 0) {
      timezone_standard =
        "+" + this.offset_hrs.toString() + ":" + this.offset_min.toString();
    } else if (this.timezone_offset_min > 0) {
      timezone_standard =
        "-" + this.offset_hrs.toString() + ":" + this.offset_min.toString();
    } else if (this.timezone_offset_min === 0) {
      timezone_standard = "+00:00";
    }
    return timezone_standard.toString();
  }
}
